// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { myAccountViewStyles } from "@awc/Overrides/Widgets/MyAccount/MyAccountView";
import { xScreen } from "@awc/XDL/Utilities";
import { css } from "styled-components";

myAccountViewStyles.mainContainer = {
    gap: 5,
};

myAccountViewStyles.mainSectionGridItem = {
    width: [12, 12, 9, 9, 9],
    css: css`
        display: flex;
        flex-direction: column;
        &&& {
            margin-top: 20px;
        }
    `,
};

myAccountViewStyles.quickLinksGridItem = {
    width: [12, 12, 3, 3, 3],
    css: css`
        ${xScreen("lte", "sm")} {
            display: none;
        }
    `,
};

myAccountViewStyles.extraCardsGridItem = {
    width: 12,
    css: css`
        grid-column: 1;
        grid-area: cards;
    `,
};

myAccountViewStyles.mainSectionGridContainer = {
    gap: 0,
};

myAccountViewStyles.welcomeWidgetsGridItem = {
    width: 12,
};

myAccountViewStyles.accountMessagesGridItem = {
    ...myAccountViewStyles.accountMessagesGridItem,
    css: css`
        padding: 8px 0 20px;
    `,
};

myAccountViewStyles.salesRepGridItem = {
    width: 12,
    css: css`
        ${({ showGrid }: any) =>
            showGrid
                ? `  display: flex;
        flex-direction: column;
        gap:28px;`
                : "display:none;"};
    `,
};
